import React, { useState } from 'react';
import { Box, Divider, BoxProps } from '@hover/blueprint';
import { Accordion } from '../../ui';
import { IFaqQuestion } from '../../../interfaces/IFaqQuestion';

interface Props extends BoxProps {
  questions: Array<IFaqQuestion>;
}

const SharedFaq: React.FC<Props> = ({ questions, ...rest }) => {
  const [current, setCurrent] = useState<string | null>(null);
  const onSelectAccordion = (title: string): void => {
    if (current === title) {
      setCurrent(null);
    } else {
      setCurrent(title);
    }
  };

  return (
    <Box maxW="790px" flexDir="column" w="100%" {...rest}>
      <Divider
        borderColor="neutral.500"
        my={0}
        borderWidth="1px"
        borderTopWidth={0}
      />
      {questions.map(q => (
        <Accordion
          isExpanded={q.title === current}
          onClick={() => {
            onSelectAccordion(q.title);
          }}
          maxW="790px"
          title={q.title}
          content={q.content}
          key={q.id}
        />
      ))}
    </Box>
  );
};

export default SharedFaq;
